import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map, List } from 'immutable';

import FormGroup from '../helpers/FormGroup';
import Select from '../helpers/Select';
import FieldError from '../helpers/FieldError';

/**
 * Stateless component for role dropdown list.
 *
 * @param props {Object}.
 * @param props.roles {Immutable.List} List of system roles.
 * @param props.formMode {string} Disabled state of control (view|edit).
 * @param props.formError {Immutable.Map} List of errors on form.
 * @param props.selectedUser {Immutable.Map} Current selected user.
 */
const UserRoleListComponent = ({ formMode, formError, selectedUser, roles }) => {
  const error = formMode === 'edit' ? formError.get('role', '') : '';
  const value = selectedUser.get('role', '');

  return (
    <FormGroup className={error ? 'has-error' : ''}>
      <Select
        className="form-control"
        defaultText="Select Roles..."
        disabled={formMode === 'view'}
        id="roleSelect"
        label="Role"
        name="role"
        nameKey="name"
        options={roles}
        value={value}
        valueKey="slug"
        showLabel
      />
      <FieldError message={error} />
    </FormGroup>
  );
};

UserRoleListComponent.propTypes = {
  formError: PropTypes.instanceOf(Map).isRequired,
  formMode: PropTypes.string.isRequired,
  roles: PropTypes.instanceOf(List).isRequired,
  selectedUser: PropTypes.instanceOf(Map).isRequired,
};

export const UserRoleList = memo(UserRoleListComponent);
